import { toJourneyError, type SmriqJourneyError } from './smriqJourneyError';

export const SERVICE_PLAN_EMPTY = 'service_plan_empty';

export const AUTO_MATCH_TOO_FEW_VISITS_MESSAGE =
    'Too few scheduled visits follow the last service entered for this plan. Check its date and mileage, or choose a longer duration if one is available.';

export function toGenerateJourneyError(error: unknown): SmriqJourneyError {
    const journeyError = toJourneyError(error);

    return journeyError.code === SERVICE_PLAN_EMPTY
        ? { ...journeyError, message: AUTO_MATCH_TOO_FEW_VISITS_MESSAGE }
        : journeyError;
}
